var module = angular.module('octopusApp.infrastructure');

module.filter('pluralize', function () {
  var vowels = ['a', 'e', 'i', 'o', 'u'];

  var plural = function(singular) {
    if (singular.slice(-1) === 'y' && !_.contains(vowels, singular.slice(-2, -1))) {
      return singular.slice(0, -1) + 'ies';
    }
    return singular + 's';
  };

  return function (input, format) {
    var singular = format || 'item';
    var count = parseInt((input || 0).toString(), 10);
    var countDesc = count.toString();
    if (count === 0 || isNaN(count)) {
      countDesc = 'no';
    }
    var pluralized = singular;
    if (count === 0 || count > 1) {
      pluralized = plural(singular);
    }

    return countDesc + ' ' + pluralized;
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/pluralize.js
// module id = 574752716960839
// module chunks = 1